import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
} from "@mui/material";
import { useSupabase } from "../providers/SupabaseProvider";
import Page from "../components/Page";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const { updatePassword, loading, session } = useSupabase();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) {
      console.log("Not a valid recovery link");
      navigate("/");
    }
  }, [navigate]);

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setError(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    try {
      await updatePassword(password);
      setMessage("Password updated successfully!");
      // Wait a moment before redirecting to show the success message
      setTimeout(() => navigate("/"), 2000);
    } catch (err: any) {
      setError(err.message || "Error updating password. Please try again.");
    }
  };

  return (
    <Page title="Reset Password">
      <Box
        sx={{
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          p: 4,
        }}
      >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, mx: "auto" }}>
          <Typography variant="h5" component="h1" align="center" gutterBottom>
            Reset Your Password
          </Typography>

          <Box component="form" onSubmit={handleResetPassword} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              type="password"
              label="New Password"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              type="password"
              label="Confirm Password"
              variant="outlined"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              sx={{ mb: 3 }}
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{ mb: 2 }}
            >
              {loading ? "Updating..." : "Update Password"}
            </Button>

            {(message || error) && (
              <Alert severity={message ? "success" : "error"} sx={{ mt: 2 }}>
                {message || error}
              </Alert>
            )}
          </Box>
        </Paper>
      </Box>
    </Page>
  );
};

export default ResetPassword;
